import { render, staticRenderFns } from "./PreloadedFiles.vue?vue&type=template&id=64c22d96&scoped=true&"
import script from "./PreloadedFiles.vue?vue&type=script&lang=js&"
export * from "./PreloadedFiles.vue?vue&type=script&lang=js&"
import style0 from "./PreloadedFiles.vue?vue&type=style&index=0&id=64c22d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c22d96",
  null
  
)

export default component.exports